export enum TrackingEvent {
  Stream3DStart = 'Start_3D_Streaming',
  VWBasicButtonClick = 'VWBasic_Button_Click',
  VWBasicLinkClick = 'VWBasic_Link_Click',
  VWBasicAccordionOpenClick = 'VWBasic_AccordionOpen_Click',
  VWBasicAccordionCloseClick = 'VWBasic_AccordionClose_Click',
  VWBasicSocialShareClick = 'VWBasic_SocialShare_Click',
  VWBasicGenericFeatureAppLoad = 'VWBasic_GenericFeatureApp_Load',
  VWBasicNavigationBarLinkClick = 'VWBasic_NavigationBarLink_Click',
  VWBasicConfiguration360ModeInteractionClick = 'VWBasic_Configuration360ModeInteraction_Click',
  VWBasicSliderElementLoad = 'VWBasic_SliderElement_Load',
  VideoPlayerVideoStart = 'VideoPlayer_Video_Start',
  VideoPlayerVideoPlayClick = 'VideoPlayer_VideoPlay_Click',
  VideoPlayerVideoPauseClick = 'VideoPlayer_VideoPause_Click',
  VideoPlayerFullscreenOpen = 'VideoPlayer_Fullscreen_Open',
  VideoPlayerFullscreenClose = 'VideoPlayer_Fullscreen_Close',
  VideoPlayerVideoMilestoneReached = 'VideoPlayer_VideoMilestone_Reached',
}

export enum EventInfoBrand {
  passenger = 'passenger',
  commercial = 'commercial',
}

export enum AccordionState {
  OPEN = 'open',
  CLOSED = 'closed',
}

export interface EventInfo {
  eventAction?: string; // set param to method call "track"
  pageId?: string; // set by tracking feature service
  pageName?: string; // set by tracking feature service
  pageCategory?: string; // set by tracking feature service
  contentId: string; // identifier what exactly the user is doing, e.g. "click share-button"
  brand?: EventInfoBrand;
}

export interface Environment {
  applicationId?: string; // set by tracking feature service
  featureAppId: string;
  featureAppIdAppVersion: string;
  language?: string; // set by tracking feature service
  country?: string; // set by tracking feature service
}

export interface User {
  loginStatus?: boolean;
  browserResolutionHeight?: string; // set by tracking feature service
  browserResolutionWidth?: string; // set by tracking feature service
  browserResolutionBreakpoint?: string; // set by tracking feature service
  browserResolutionOrientation?: string; // set by tracking feature service
  dealerStatus?: string; // set by tracking feature service using mydealer service
  dealerInformationBnr?: string; // set by tracking feature service using mydealer service
  dealerInformationName?: string; // set by tracking feature service using mydealer service
  dealerInformationType?: string; // set by tracking feature service using mydealer service
  dealerInformationBrand?: string; // set by tracking feature service using mydealer service
  dealerInformationCountry?: string; // set by tracking feature service using mydealer service
}

export interface Video {
  playerName?: string;
  title?: string;
  id?: string;
  platform?: string;
  url?: string;
  milestone?: number;
  timeplayed?: string;
  length?: string;
}

export interface Link {
  url?: string;
  name?: string;
  newTab?: boolean;
}

export interface Process {
  Name?: string;
  StepName?: string;
  StepNumber?: string;
  Components?: Array<string>;
}

export interface Social {
  Platform?: string;
  ShareConsent?: boolean;
}

export interface Accordion {
  groupItemName?: string;
  groupItemState?: string;
}

export interface Content {
  Name?: string;
  ItemCount?: number;
  ItemPosition?: number;
  BrochureId?: string;
}

export interface Configuration {
  CarlineId?: string;
  CarlineName?: string;
  SalesgroupId?: string;
  SalesgroupName?: string;
  EquipmentlineName?: string;
  EngineName?: string;
  EnginePowerHPKW?: string;
  ModelId?: string;
  ModelTrimFeatures?: string;
  ModelName?: string;
  ModelYear?: string;
  ModelModelVersion?: number;
  Marketingcode?: string;
}

export interface Partner {
  informationBnr?: string;
  informationName?: string;
  informationZIP?: string;
  informationType?: string;
  informationBrand?: string;
  informationCountry?: string;
}

export interface PartialEventData {
  eventInfo?: EventInfo;
  environment?: Environment;
  user?: User;
  content?: Content;
  link?: Link;
  video?: Video;
  social?: Social;
  accordion?: Accordion;
  configuration?: Configuration;
  partner?: Partner;
  process?: Process;
}
